export default {
  API_URL: 'https://lib.uef.edu.vn/',
  getApiUrl: () => 'http://thuvienuef.libvn.net/', //  window.getLinkHomepage(),
  // getApiUrl: () => 'http://thuvienbinhduong.libvn.net/',
};
